import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import { FETCH_UPTIME_REPORT, DOWNLOAD_UPTIME_REPORT } from 'actions/uptimeReport';

function* fetchUptimeReport(action) {
    try {
        const response = yield call(API.getUptimeReportData, action.payload);
        yield put({ type: FETCH_UPTIME_REPORT.SUCCESS, payload: response.data });
        action.cb && action.cb(response);
    } catch (e) {
        yield put({ type: FETCH_UPTIME_REPORT.FAIL, payload: { error: e } });
        action.cb && action.cb(e);
    }
}

function* downloadUptimeReport(action) {
    try {
        const response = yield call(API.downloadUptimeReportData, action.payload);
        yield put({ type: DOWNLOAD_UPTIME_REPORT.SUCCESS, payload: response.data });
        action.cb && action.cb(response);
    } catch (e) {
        yield put({ type: DOWNLOAD_UPTIME_REPORT.FAIL, payload: { error: e } });
        action.cb && action.cb(e);
    }
}

function* uptimeReportSaga() {
    yield takeLatest(FETCH_UPTIME_REPORT.REQUEST, fetchUptimeReport);
    yield takeLatest(DOWNLOAD_UPTIME_REPORT.REQUEST, downloadUptimeReport);
}

export default uptimeReportSaga;